import { Document, Page, Text, View, StyleSheet, Image, Font } from '@react-pdf/renderer';
import React from 'react';
import logo from 'images/hostplatform-logo.png';

Font.register('https://nebulapi-public-prd.s3.ap-southeast-1.amazonaws.com/chinese.msyh.ttf', { family: 'Microsoft YaHei' });

Font.register('https://nebula-stg-images.s3.ap-southeast-1.amazonaws.com/Roboto-Bold.ttf', { family: 'Roboto' });

Font.registerEmojiSource({
  format: 'png',
  url: 'https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/72x72/'
});

const HPCodeAndDescription = [
  {
    code: '',
    description: 'HOST PLATFORM -Yearly Subscription Plan (With HostProtect)',
    subProduct: [
      {
        subCode: 'HP-ENT-1Y',
        subDescription: 'HOST PLATFORM-ENTRY-1Y Subscription'
      },
      {
        subCode: 'HP-ENT-MNG-1Y',
        subDescription: ' HOSTMANAGE ENTRY 1Y Subscription'
      },
      {
        subCode: 'HP-ENT-SPP-1Y',
        subDescription: 'HOST PLATFORM-ENTRY-Tech Support NB,Online/Email Only'
      }
    ]
  },
  {
    code: '',
    description: 'HOST PROTECT -Yearly Subscription Plan',
    subProduct: [
      {
        subCode: ' HP-PP-1Y-GE',
        subDescription: 'HostProtect (RM30k AR, RM75K PL,RM5K PG)'
      }
    ]
  }
];

const styles = StyleSheet.create({
  page: {
    backgroundColor: '#FFFFFF',
    padding: 30
  },
  pageInventorySummary: {
    backgroundColor: '#FFFFFF',
    padding: 15
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 5
  },
  logo: {
    width: 130,
    height: 70,
    marginRight: 5
  },
  companyInfo: {
    fontSize: 8,
    flex: 1,
    marginRight: 20
  },
  invoice: {
    fontSize: 24,
    fontWeight: 'bolder'
  },
  line: {
    borderBottomWidth: 1,
    borderBottomColor: '#000000',
    marginVertical: 6
  },
  hostInfoContainer: {
    flexDirection: 'row',
    fontSize: 8,
    padding: 25,
    paddingBottom: 0,
    paddingTop: 0
  },
  hostInfoLeft: {
    flex: 1,
    alignItems: 'flex-start'
  },
  hostInfoRight: {
    flex: 1,
    alignItems: 'flex-end',
    marginRight: 60
  },
  invoiceInfoRight: {
    flex: 1,
    alignItems: 'flex-end',
    marginRight: 14
  },
  hostInfoText: {
    flexDirection: 'row',
    marginBottom: 5,
    alignItems: 'flex-start'
  },
  hostInfoLabel: {
    width: 40,
    marginRight: 5
  },
  hostInfoValue: {
    flex: 1
  },
  borderBottom: {
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderColor: 'black'
  },
  borderTop: {
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderColor: 'black'
  },
  borderRight: {
    borderRightWidth: 1,
    borderRightStyle: 'solid',
    borderColor: 'black'
  },
  borderLeft: {
    borderLeftWidth: 1,
    borderLeftStyle: 'solid',
    borderColor: 'black'
  },
  paymentInfo: {
    marginTop: 30,
    fontSize: 8
  },
  paymentInfoText: {
    paddingBottom: 5
  },
  tableHeader: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: 'auto'
  },
  tableInventorySummaryHeader: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%'
  },
  tableCell: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    paddingTop: 6
  },
  productName: {
    textAlign: 'left',
    paddingLeft: 8,
    fontWeight: 'bold',
    textDecoration: 'underline',
    paddingBottom: 2
  },
  productCode: {
    textAlign: 'left',
    paddingLeft: 8,
    fontWeight: 'bolder',
    paddingBottom: 2
  },
  productText: {
    textAlign: 'left',
    paddingLeft: 8
  },
  productDescription: {
    textAlign: 'left',
    paddingLeft: 8,
    paddingBottom: 12
  },
  footerLabel: {
    textAlign: 'right',
    paddingRight: 5,
    fontWeight: 'bold'
  },
  footerValue: {
    textAlign: 'right',
    paddingRight: 2
  }
});

// Define the PDF Document
const HostProtectInvoicePDF = ({
  taxesApplied,
  subTotal,
  subTotalAfterDiscount,
  systemProductSubTotal,
  grandTotal,
  hostProtectProducts,
  date,
  invoiceRef,
  discountApplied,
  hostName
}) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.header}>
        <Image style={styles.logo} src={logo} />
        <View style={styles.companyInfo}>
          <Text>HOST PLATFORM SDN BHD (1238452-V)</Text>
          <Text>LOT NO 7F-2, 7 FLOOR, TOWER 4, @ PFCC,</Text>
          <Text>JALAN PUTERI 1/2, BANDAR PUTERI,</Text>
          <Text>47100, PUCHONG,SELANGOR MALAYSIA</Text>
          <Text>Phone : 03-7886 7829</Text>
        </View>
        <Text style={styles.invoice}>P-INVOICE</Text>
      </View>
      <View style={styles.line} />
      {/*<! -------------- Table Header --------------------!> */}
      <View style={styles.hostInfoContainer}>
        <View style={styles.hostInfoLeft}>
          <View style={styles.hostInfoText}>
            <Text style={styles.hostInfoLabel}>Attn</Text>
            <Text style={styles.hostInfoValue}>: {hostName}</Text>
          </View>
          <View style={styles.hostInfoText}>
            <Text style={styles.hostInfoLabel}>Host</Text>
            <Text style={styles.hostInfoValue}>: </Text>
          </View>
          <View style={styles.hostInfoText}>
            <Text style={styles.hostInfoLabel}>Remark</Text>
            <Text style={styles.hostInfoValue}>: HostProtect Subscription</Text>
          </View>
        </View>
        <View style={styles.hostInfoRight}>
          <View style={styles.hostInfoText}>
            <Text style={styles.hostInfoLabel}>Date</Text>
            <Text style={styles.hostInfoValue}>: {date}</Text>
          </View>
          <View style={styles.hostInfoText}>
            <Text style={styles.hostInfoLabel}>REF</Text>
            <Text style={styles.hostInfoValue}>: {invoiceRef}</Text>
          </View>
        </View>
      </View>
      <View style={{ ...styles.tableHeader, backgroundColor: '#D3D3D3' }}>
        <View
          style={{
            ...styles.tableCell,
            width: '15%',
            ...styles.borderBottom,
            ...styles.borderTop,
            ...styles.borderLeft
          }}
        >
          <Text style={{ fontSize: 8 }}>Product Code</Text>
        </View>
        <View
          style={{
            ...styles.tableCell,
            width: '55%',
            ...styles.borderBottom,
            ...styles.borderTop,
            ...styles.borderLeft
          }}
        >
          <Text style={{ fontSize: 8 }}>Description</Text>
        </View>
        <View
          style={{
            ...styles.tableCell,
            width: '6%',
            ...styles.borderBottom,
            ...styles.borderTop,
            ...styles.borderLeft
          }}
        >
          <Text style={{ fontSize: 8 }}>Item</Text>
        </View>
        <View
          style={{
            ...styles.tableCell,
            width: '6%',
            ...styles.borderBottom,
            ...styles.borderTop,
            ...styles.borderLeft
          }}
        >
          <Text style={{ fontSize: 8 }}>Qty</Text>
        </View>
        <View
          style={{
            ...styles.tableCell,
            width: '18%',
            ...styles.borderBottom,
            ...styles.borderTop,
            ...styles.borderLeft,
            ...styles.borderRight
          }}
        >
          <Text style={{ fontSize: 8 }}>Price (RM)</Text>
          <View style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
            <View
              style={{
                width: '50%',
                ...styles.borderRight
              }}
            >
              <Text style={{ fontSize: 8, paddingTop: 5 }}>List Price</Text>
            </View>
            <View style={{ width: '50%' }}>
              <Text style={{ fontSize: 8, paddingTop: 5 }}>Total</Text>
            </View>
          </View>
        </View>
      </View>
      {/*<! -------------- Table Body (System) --------------------!> */}
      {HPCodeAndDescription.map((product, index) => (
        <View key={index} style={styles.tableHeader}>
          <View style={{ ...styles.tableCell, width: '15%', ...styles.borderLeft, paddingTop: 12, paddingBottom: 12 }}>
            <Text style={{ fontSize: 8, ...styles.productCode, fontFamily: 'Roboto' }}>{product.code || '\u00A0'}</Text>
            <View>
              {product.subProduct
                ? product.subProduct.map((subProduct, subIndex) => (
                    <Text key={subIndex} style={{ fontSize: 8, ...styles.productText, paddingTop: 4 }}>
                      {subProduct.subCode}
                    </Text>
                  ))
                : null}
            </View>
          </View>
          <View style={{ ...styles.tableCell, width: '55%', ...styles.borderLeft, paddingTop: 12, paddingBottom: 12 }}>
            <Text style={{ fontSize: 8, ...styles.productName, fontFamily: 'Roboto' }}>{product.description}</Text>
            <View>
              {product.subProduct
                ? product.subProduct.map((subProduct, subIndex) => (
                    <Text key={subIndex} style={{ fontSize: 8, ...styles.productText, paddingTop: 4 }}>
                      {subProduct.subDescription}
                    </Text>
                  ))
                : null}
            </View>
          </View>
          <View style={{ ...styles.tableCell, width: '6%', ...styles.borderLeft, paddingTop: 12, paddingBottom: 12 }}>
            <Text style={{ fontSize: 8 }}>unit</Text>
          </View>
          <View style={{ ...styles.tableCell, width: '6%', ...styles.borderLeft, paddingTop: 12, paddingBottom: 12 }}>
            <Text style={{ fontSize: 8 }}>{hostProtectProducts.quantity}</Text>
          </View>
          <View
            style={{
              ...styles.tableCell,
              width: '18%',
              ...styles.borderLeft,
              ...styles.borderRight,
              display: 'flex',
              flexDirection: 'row',
              paddingTop: 0
            }}
          >
            <View style={{ width: '50%', ...styles.borderRight, borderRightWidth: '1', borderRighStyle: 'solid', borderColor: 'black' }}>
              <Text style={{ fontSize: 8, paddingTop: 12 }}>{index === 0 ? hostProtectProducts.pricing : 0}</Text>
            </View>
            <View style={{ width: '50%' }}>
              <Text style={{ fontSize: 8, paddingTop: 12 }}>{index === 0 ? hostProtectProducts.totalPrice : 0}</Text>
            </View>
          </View>
        </View>
      ))}

      {/*<! -------------- Table Footer --------------------!> */}
      <View style={{ ...styles.tableHeader }} wrap={false}>
        <View
          style={{
            ...styles.tableCell,
            width: '15%',
            ...styles.borderLeft,
            ...styles.borderTop
          }}
        ></View>
        <View
          style={{
            ...styles.tableCell,
            width: '55%',
            backgroundColor: '#D3D3D3',
            ...styles.borderLeft,
            ...styles.borderTop
          }}
        >
          <Text style={{ fontSize: 8, ...styles.footerLabel, fontFamily: 'Roboto' }}>Sub-Total (Before Tax)</Text>
        </View>
        <View
          style={{
            ...styles.tableCell,
            width: '6%',
            ...styles.borderLeft,
            ...styles.borderTop
          }}
        ></View>
        <View
          style={{
            ...styles.tableCell,
            width: '6%',
            ...styles.borderLeft,
            ...styles.borderTop
          }}
        ></View>
        <View
          style={{
            ...styles.tableCell,
            width: '18%',
            ...styles.borderLeft,
            ...styles.borderRight,
            ...styles.borderTop,

            display: 'flex',
            flexDirection: 'row',
            paddingTop: 0
          }}
        >
          <View
            style={{
              width: '50%',
              height: 'auto',
              borderRightWidth: 1,
              borderRightStyle: 'solid',
              borderColor: 'black'
            }}
          ></View>
          <View style={{ width: '50%' }}>
            <Text style={{ fontSize: 8, paddingTop: 7, ...styles.footerValue }}>{subTotal.toFixed(2)}</Text>
          </View>
        </View>
      </View>
      {/*<! -------------- Table Footer - Discount--------------------!> */}
      {discountApplied._id && (
        <View wrap={false}>
          <View style={{ ...styles.tableHeader }}>
            <View
              style={{
                ...styles.tableCell,
                width: '15%',
                ...styles.borderLeft,
                ...styles.borderTop
              }}
            ></View>
            <View
              style={{
                ...styles.tableCell,
                width: '55%',
                backgroundColor: '#D3D3D3',
                ...styles.borderLeft,
                ...styles.borderTop
              }}
            >
              <Text style={{ fontSize: 8, ...styles.footerLabel, fontFamily: 'Roboto' }}>
                {discountApplied.name} @ {discountApplied.amount}
                {discountApplied.type === 'percentage' ? '%' : ''}
              </Text>
            </View>
            <View
              style={{
                ...styles.tableCell,
                width: '6%',
                ...styles.borderLeft,
                ...styles.borderTop
              }}
            ></View>
            <View
              style={{
                ...styles.tableCell,
                width: '6%',
                ...styles.borderLeft,
                ...styles.borderTop
              }}
            ></View>
            <View
              style={{
                ...styles.tableCell,
                width: '18%',
                ...styles.borderLeft,
                ...styles.borderRight,
                ...styles.borderTop,
                display: 'flex',
                flexDirection: 'row',
                paddingTop: 0
              }}
            >
              <View
                style={{
                  width: '50%',
                  height: 'auto',
                  borderRightWidth: 1,
                  borderRightStyle: 'solid',
                  borderColor: 'black'
                }}
              ></View>
              <View style={{ width: '50%' }}>
                <Text style={{ fontSize: 8, paddingTop: 7, ...styles.footerValue }}>
                  -
                  {discountApplied.type === 'percentage'
                    ? (systemProductSubTotal * (discountApplied.amount / 100)).toFixed(2)
                    : discountApplied.amount.toFixed(2)}
                </Text>
              </View>
            </View>
          </View>

          <View style={{ ...styles.tableHeader }}>
            <View
              style={{
                ...styles.tableCell,
                width: '15%',
                ...styles.borderLeft,
                ...styles.borderTop,
                ...styles.borderBottom,
                marginBottom: 1
              }}
            ></View>
            <View
              style={{
                ...styles.tableCell,
                width: '55%',
                backgroundColor: '#D3D3D3',
                ...styles.borderLeft,
                ...styles.borderTop,
                ...styles.borderBottom,
                marginBottom: 1
              }}
            >
              <Text style={{ fontSize: 8, ...styles.footerLabel, fontFamily: 'Roboto' }}>Sub-Total (Before Tax)</Text>
            </View>
            <View
              style={{
                ...styles.tableCell,
                width: '6%',
                ...styles.borderLeft,
                ...styles.borderTop,
                ...styles.borderBottom,
                marginBottom: 1
              }}
            ></View>
            <View
              style={{
                ...styles.tableCell,
                width: '6%',
                ...styles.borderLeft,
                ...styles.borderTop,
                ...styles.borderBottom,
                marginBottom: 1
              }}
            ></View>
            <View
              style={{
                ...styles.tableCell,
                width: '18%',
                ...styles.borderLeft,
                ...styles.borderRight,
                ...styles.borderTop,
                display: 'flex',
                flexDirection: 'row',
                paddingTop: 0,
                ...styles.borderBottom,
                marginBottom: 1
              }}
            >
              <View
                style={{
                  width: '50%',
                  height: 'auto',
                  borderRightWidth: 1,
                  borderRightStyle: 'solid',
                  borderColor: 'black',
                  marginBottom: 1
                }}
              ></View>
              <View style={{ width: '50%' }}>
                <Text style={{ fontSize: 8, paddingTop: 7, ...styles.footerValue, fontFamily: 'Roboto' }}>
                  {discountApplied.type === 'percentage'
                    ? (subTotal - (systemProductSubTotal * (discountApplied.amount / 100)).toFixed(2)).toFixed(2)
                    : (subTotal - discountApplied.amount).toFixed(2)}
                </Text>
              </View>
            </View>
          </View>
        </View>
      )}
      {/*<! -------------- Taxes Footer - TAX --------------------!> */}
      {taxesApplied.map((tax, index) => (
        <View style={{ ...styles.tableHeader }} wrap={false}>
          <View
            style={{
              ...styles.tableCell,
              width: '15%',
              ...styles.borderLeft,
              ...styles.borderTop
            }}
          ></View>
          <View
            style={{
              ...styles.tableCell,
              width: '55%',
              backgroundColor: '#D3D3D3',
              ...styles.borderLeft,
              ...styles.borderTop
            }}
          >
            <Text style={{ fontSize: 8, ...styles.footerLabel, fontFamily: 'Roboto' }}>
              {tax.name} @ {tax.amount}
              {tax.type === 'percentage' ? '%' : ''}
            </Text>
          </View>
          <View
            style={{
              ...styles.tableCell,
              width: '6%',
              ...styles.borderLeft,
              ...styles.borderTop
            }}
          ></View>
          <View
            style={{
              ...styles.tableCell,
              width: '6%',
              ...styles.borderLeft,
              ...styles.borderTop
            }}
          ></View>
          <View
            style={{
              ...styles.tableCell,
              width: '18%',
              ...styles.borderLeft,
              ...styles.borderRight,
              ...styles.borderTop,

              display: 'flex',
              flexDirection: 'row',
              paddingTop: 0
            }}
          >
            <View
              style={{
                width: '50%',
                height: 'auto',
                borderRightWidth: 1,
                borderRightStyle: 'solid',
                borderColor: 'black'
              }}
            ></View>
            <View style={{ width: '50%' }}>
              <Text style={{ fontSize: 8, paddingTop: 7, ...styles.footerValue }}>
                {tax.type === 'percentage'
                  ? subTotalAfterDiscount !== undefined
                    ? (subTotalAfterDiscount * (tax.amount / 100)).toFixed(2)
                    : (subTotal * (tax.amount / 100)).toFixed(2)
                  : tax.amount}
              </Text>
            </View>
          </View>
        </View>
      ))}
      {/*<! -------------- END Taxes Footer --------------------!> */}
      <View style={{ ...styles.tableHeader }} wrap={false}>
        <View
          style={{
            ...styles.tableCell,
            width: '15%',
            ...styles.borderTop,
            ...styles.borderLeft,
            ...styles.borderBottom
          }}
        ></View>
        <View
          style={{
            ...styles.tableCell,
            width: '55%',
            backgroundColor: '#D3D3D3',
            ...styles.borderTop,
            ...styles.borderLeft,
            ...styles.borderBottom
          }}
        >
          <Text style={{ fontSize: 8, ...styles.footerLabel, fontFamily: 'Roboto' }}>Grand Total</Text>
        </View>
        <View
          style={{
            ...styles.tableCell,
            width: '6%',
            ...styles.borderTop,
            ...styles.borderLeft,
            ...styles.borderBottom
          }}
        ></View>
        <View
          style={{
            ...styles.tableCell,
            width: '6%',
            ...styles.borderTop,
            ...styles.borderLeft,
            ...styles.borderBottom
          }}
        ></View>
        <View
          style={{
            ...styles.tableCell,
            width: '18%',
            ...styles.borderTop,
            ...styles.borderLeft,
            ...styles.borderRight,
            ...styles.borderBottom,

            display: 'flex',
            flexDirection: 'row',
            paddingTop: 0
          }}
        >
          <View
            style={{
              width: '50%',
              height: 'auto',
              borderRightWidth: 1,
              borderRightStyle: 'solid',
              borderColor: 'black'
            }}
          ></View>
          <View style={{ width: '50%' }}>
            <Text style={{ fontSize: 8, paddingTop: 7, ...styles.footerValue, fontFamily: 'Roboto' }}>{grandTotal.toFixed(2)}</Text>
          </View>
        </View>
      </View>
      <View
        style={{
          width: '100%',
          borderBottomWidth: 1, // Line thickness
          borderColor: 'black', // Line color
          marginTop: 1 // Add a little space between the row and the line
        }}
      />
      <View style={styles.paymentInfo}>
        <Text style={{ ...styles.paymentInfoText }}>Payment:</Text>
        <Text style={{ ...styles.paymentInfoText }}>
          1. All cheques should be crossed and make payable to "HOST PLATFORM SDN BHD" or Bank into our bank account MAYBANK (Account Number : 5123
          5262 3290)
        </Text>
        <Text style={{ ...styles.paymentInfoText }}>
          2. Please include our invoice number in your payment description & email to : admin@hostplatform.com
        </Text>
        <Text style={{ ...styles.paymentInfoText }}>3. No refund upon payment made</Text>
        <Text style={{ ...styles.paymentInfoText }}>4. 30% penalty charges would be imposed for any cancellation of orders</Text>
        <Text style={{ paddingBottom: 20 }}>5. All prices are subject to 8% SST charges</Text>
        <Text>Please do not hesitate to contact the undersigned for further assistance.</Text>
      </View>
    </Page>

    {/*<! -------------- PDF Inventory Summary Page --------------------!> */}

    <Page size="A4" style={styles.pageInventorySummary}>
      <View style={{ ...styles.tableHeader, backgroundColor: '#D3D3D3' }}>
        <View style={{ ...styles.tableCell, width: '4%', ...styles.borderTop, ...styles.borderLeft }}>
          <Text style={{ fontSize: 8, fontFamily: 'Roboto' }}>No</Text>
        </View>
        <View style={{ ...styles.tableCell, width: '15%', ...styles.borderTop, ...styles.borderLeft }}>
          <Text style={{ fontSize: 8, fontFamily: 'Roboto' }}>Property Name</Text>
        </View>
        <View style={{ ...styles.tableCell, width: '15%', ...styles.borderTop, ...styles.borderLeft }}>
          <Text style={{ fontSize: 8, fontFamily: 'Roboto' }}>Unit Name</Text>
        </View>
        <View style={{ ...styles.tableCell, width: '9%', ...styles.borderTop, ...styles.borderLeft }}>
          <Text style={{ fontSize: 8, fontFamily: 'Roboto' }}>Host Protect</Text>
        </View>
        <View style={{ ...styles.tableCell, width: '10%', ...styles.borderTop, ...styles.borderLeft }}>
          <Text style={{ fontSize: 8, fontFamily: 'Roboto' }}>Owner's Name</Text>
        </View>
        <View style={{ ...styles.tableCell, width: '10%', ...styles.borderTop, ...styles.borderLeft }}>
          <Text style={{ fontSize: 8, fontFamily: 'Roboto' }}>IC Owner</Text>
        </View>
        <View style={{ ...styles.tableCell, width: '28%', ...styles.borderTop, ...styles.borderLeft }}>
          <Text style={{ fontSize: 8, fontFamily: 'Roboto' }}>Address</Text>
        </View>
        <View style={{ ...styles.tableCell, width: '9%', ...styles.borderTop, ...styles.borderLeft, ...styles.borderRight }}>
          <Text style={{ fontSize: 8, fontFamily: 'Roboto' }}>Subscription Fee</Text>
        </View>
      </View>

      {hostProtectProducts.hostProtectUnits &&
        hostProtectProducts.hostProtectUnits.map((unit, index) => (
          <View key={index} style={styles.tableInventorySummaryHeader}>
            <View style={{ ...styles.tableCell, width: '4%', ...styles.borderTop, ...styles.borderLeft, ...styles.borderBottom }}>
              <Text style={{ fontSize: 8 }}>{index + 1}</Text>
            </View>
            <View style={{ ...styles.tableCell, width: '15%', ...styles.borderTop, ...styles.borderLeft, ...styles.borderBottom }}>
              <Text style={{ fontSize: 8 }}>{unit.propertyName || '-'}</Text>
            </View>
            <View style={{ ...styles.tableCell, width: '15%', ...styles.borderTop, ...styles.borderLeft, ...styles.borderBottom }}>
              <Text style={{ fontSize: 8 }}>{unit.unitName || '-'}</Text>
            </View>
            <View style={{ ...styles.tableCell, width: '9%', ...styles.borderTop, ...styles.borderLeft, ...styles.borderBottom }}>
              <Text style={{ fontSize: 8 }}>New</Text>
            </View>
            <View style={{ ...styles.tableCell, width: '10%', ...styles.borderTop, ...styles.borderLeft, ...styles.borderBottom }}>
              <Text style={{ fontSize: 8 }}>{unit.ownerName}</Text>
            </View>
            <View style={{ ...styles.tableCell, width: '10%', ...styles.borderTop, ...styles.borderLeft, ...styles.borderBottom }}>
              <Text style={{ fontSize: 8 }}>{unit.icOwner}</Text>
            </View>
            <View style={{ ...styles.tableCell, width: '28%', ...styles.borderTop, ...styles.borderLeft, ...styles.borderBottom }}>
              <Text style={{ fontSize: 8 }}>{unit.address}</Text>
            </View>
            <View
              style={{ ...styles.tableCell, width: '9%', ...styles.borderTop, ...styles.borderLeft, ...styles.borderBottom, ...styles.borderRight }}
            >
              <Text style={{ fontSize: 8 }}>{hostProtectProducts.pricing}</Text>
            </View>
          </View>
        ))}
    </Page>
  </Document>
);

export default HostProtectInvoicePDF;
